import React from "react";
import {number, arrayOf, shape, string} from "prop-types";
import styles from "./RegionEventGroup.module.styl";
import RegionEventsRow from "../RegionEventsRow/RegionEventsRow";

export default function RegionEventGroup({ items, groupName }){
    return <div>
        <div className={styles.groupName}>
            {groupName}
        </div>
        {items.map((item, index) =>
            <RegionEventsRow key={item.id} regionEvent={item} index={index+1}/>)}
    </div>
}

RegionEventGroup.propTypes = {
    items: arrayOf(
        shape({
            id: number,
            name: string,
            sportTypeName: string,
            status: string,
            federationName: string,
            startDate: string,
            endDate: string,
            participantsData: shape({
                participantsCount: number,
                participantsWithResult: number
            }),
            kpNumber: string
    })),
    groupName: string
}